export default function mapObject<K extends string, T, U>(obj: Record<K, T>, callback: (value: T, key: K) => U): Record<K, U> {
  return Object.keys(obj).reduce((result, key) => {
    result[key as K] = callback(obj[key as K], key as K);
    return result;
  }, {} as Record<K, U>);
}
